const ua = navigator.userAgent || ''

export const isAndroid = /android/i.test(ua)

export const isIos = /iphone|ipad|ipod/i.test(ua)

export const isWechat = /micromessenger\/([\d.]+)/i.test(ua)
